module.exports = __webpack_public_path__ + "img/03.01ffb7cb.png";